import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import type {
    CreateEmptyProductBody,
    CreateEmptyProductData,
} from 'api/dist/routes/organization/[organization_id]/brands/[brand_slug]/products/empty'

export type ICreateEmptyProductResponse = CreateEmptyProductData

export class CreateEmptyProductMutation {
    static async call(api: IApi, params: { organizationId: string; brandSlug: string; data: CreateEmptyProductBody }) {
        return api
            .post<
                ICreateEmptyProductResponse,
                CreateEmptyProductBody
            >(`/organization/${params.organizationId}/brands/${params.brandSlug}/products/empty`, params.data)
            .then((res) => res.data)
    }
}

export function useCreateEmptyProductMutation() {
    const { api, apiParams } = useApiToolbox()

    return useApiMutation({
        mutationFn: (params: { brandSlug: string; variantId?: string; currentModeId?: string }) => {
            if (!apiParams.organizationId) return Promise.reject('Workspace not found')

            return CreateEmptyProductMutation.call(api, {
                organizationId: apiParams.organizationId,
                brandSlug: params.brandSlug,
                data: { variantId: params.variantId, currentModeId: params.currentModeId },
            })
        },
    })
}
